/**
 * WARNING!
 *
 * This wrap should be used if need to open file picker window in `Firefox`.
 * `Firefox` hasn't method that can open window and library fires `onclick` action on input.
 * So if input was umounted like it happens in select after click, file picker windown won't open.
 *
 */
function FileUploadConstantInputWrap({
  children,
  disabled,
  getFileAttachInputProps,
}) {
  return (
    <>
      {children}
      {!disabled ? <input {...getFileAttachInputProps()} /> : null}
    </>
  )
}

export default FileUploadConstantInputWrap
